'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex: 0 0 ', 'px;\n  height: ', 'px;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex: 0 0 ', 'px;\n  height: ', 'px;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-radius: 50%;\n  background: ', ';\n  border-color: ', ';\n  border-width: 2px;\n  border-style: solid;\n'], ['\n  border-radius: 50%;\n  background: ', ';\n  border-color: ', ';\n  border-width: 2px;\n  border-style: solid;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getAnyCompanyLogo = require('conversations-schema/chat-heading-config/operators/getAnyCompanyLogo');

var _UIAvatar = require('ui-addon-avatars/UIAvatar');

var _UIAvatar2 = _interopRequireDefault(_UIAvatar);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _Constants = require('ui-addon-avatars/Constants');

var _AvatarSize = require('conversations-schema/constants/AvatarSize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BORDER_WIDTH = 2;

var CustomUIAvatarWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'CustomChatHeading__CustomUIAvatarWrapper'
})(_templateObject, function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return _Constants.AVATAR_SIZES[size] + BORDER_WIDTH * 2;
});

var CustomUIAvatar = (0, _styledComponents2.default)(_UIAvatar2.default).withConfig({
  displayName: 'CustomChatHeading__CustomUIAvatar'
})(_templateObject2, function (props) {
  return props.borderColor;
}, function (props) {
  return props.borderColor;
});

var CustomChatHeading = function (_React$Component) {
  _inherits(CustomChatHeading, _React$Component);

  function CustomChatHeading() {
    _classCallCheck(this, CustomChatHeading);

    return _possibleConstructorReturn(this, (CustomChatHeading.__proto__ || Object.getPrototypeOf(CustomChatHeading)).apply(this, arguments));
  }

  _createClass(CustomChatHeading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          borderColor = _props.borderColor,
          chatHeadingConfig = _props.chatHeadingConfig,
          size = _props.size;


      var borderStyles = {
        border: '2px solid ' + borderColor,
        background: '' + borderColor,
        borderRadius: '50%'
      };

      var src = (0, _getAnyCompanyLogo.getAnyCompanyLogo)(chatHeadingConfig);

      if (!chatHeadingConfig) {
        return null;
      }

      return _react2.default.createElement(
        CustomUIAvatarWrapper,
        null,
        _react2.default.createElement(CustomUIAvatar, {
          className: 'chat-head-avatar',
          size: size,
          src: src,
          style: borderStyles,
          type: 'hubSpotUserEmail'
        })
      );
    }
  }]);

  return CustomChatHeading;
}(_react2.default.Component);

CustomChatHeading.propTypes = {
  borderColor: _react.PropTypes.string.isRequired,
  chatHeadingConfig: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('CompanyChatHeadingConfig'), (0, _RecordPropType2.default)('OwnerChatHeadingConfig')]),
  size: _react.PropTypes.string.isRequired
};

CustomChatHeading.defaultProps = { size: _AvatarSize.SMALL };

exports.default = CustomChatHeading;
module.exports = exports['default'];